// @flow
import * as React from 'react';
import { withTheme } from 'styled-components';
import { translate } from 'react-i18next';
import TitledCard from 'common/components/cards/TitledCard';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { Label } from '../../styles';
import { StationLink } from '../../../domain/StationLink';


type Props = {
  onDelete: () => void;
  onUpdate: (title: string, url: string) => void;
  link: StationLink;
  t: any;
  theme: Object;
}


function StationLinkComponent(props: Props) {
  return (
    <TitledCard title={props.link.name} collapsable withMargin>
      <div>
        <Label>{props.t('title')}</Label>
        <TextField
          fullWidth
          id={'link-title-' + props.link.name}
          defaultValue={props.link.name}
          onChange={(e, v) => props.onUpdate(v, props.link.url)}
        />
      </div>
      <div>
        <Label>URL</Label>
        <TextField
          fullWidth
          id={'link-url-' + props.link.name}
          defaultValue={props.link.url}
          onChange={(e, v) => props.onUpdate(props.link.name, v)}
        />
      </div>
      <div>
        <RaisedButton
          onClick={props.onDelete}
          label={props.t('delete')}
        />
      </div>
    </TitledCard>
  );
}

export default withTheme(translate('radioConfiguration')(StationLinkComponent));



// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/components/playerConfigurationForm/statsRadioPlayer/StationLinkComponent.js